import { render, staticRenderFns } from "./act.vue?vue&type=template&id=5634e74c&scoped=true&"
import script from "./act.vue?vue&type=script&lang=js&"
export * from "./act.vue?vue&type=script&lang=js&"
import style0 from "./act.vue?vue&type=style&index=0&id=5634e74c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634e74c",
  null
  
)

export default component.exports